// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".yVURwQSm5Gcp_YB9NlLP .ant-table-cell {\n\tfont-size: 13px !important;\n}\n", "",{"version":3,"sources":["webpack://./client/src/screens/general/HomeScreen/dashboards/PayablesDashboard.module.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B","sourcesContent":[".table :global(.ant-table-cell) {\n\tfont-size: 13px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": "yVURwQSm5Gcp_YB9NlLP"
};
export default ___CSS_LOADER_EXPORT___;
